import { render } from "./Label.vue?vue&type=template&id=ae5c3c1a&ts=true"
import script from "./Label.vue?vue&type=script&setup=true&lang=ts"
export * from "./Label.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/label/Label.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ae5c3c1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ae5c3c1a', __exports__)) {
    api.reload('ae5c3c1a', __exports__)
  }
  
  module.hot.accept("./Label.vue?vue&type=template&id=ae5c3c1a&ts=true", () => {
    api.rerender('ae5c3c1a', render)
  })

}


export default __exports__